import intl from "react-intl-universal";
import { TbAdjustmentsHorizontal } from "react-icons/tb";
import { ModernFilterBar } from "../../../../Components/Molecules/Filters/ModernFilterBar";
import { CheckboxListFilterPanel } from "../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_CUSTOMERS_FILTERS,
  buildCustomersFilterTags,
  getCustomersCountries,
  getCustomersKycStatuses,
  hasActiveCustomersFilters,
  isCustomersChipFilterActive,
  removeCustomersFilterTag,
} from "../crossborderCustomersFilters";

export const CrossborderCustomersFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
}) => {
  const filterButtons = [
    {
      id: "country",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("crossborder.customers.filterCountry"),
      active: isCustomersChipFilterActive(filters, "country"),
    },
    {
      id: "kyc",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("crossborder.customers.filterKyc"),
      active: isCustomersChipFilterActive(filters, "kyc"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "country":
        return (
          <CheckboxListFilterPanel
            options={getCustomersCountries()}
            selectedValues={draft.countries}
            onChange={(countries) => onChange({ ...draft, countries })}
            idPrefix="crossborder-customers-country"
          />
        );
      case "kyc":
        return (
          <CheckboxListFilterPanel
            options={getCustomersKycStatuses()}
            selectedValues={draft.kycStatuses}
            onChange={(kycStatuses) => onChange({ ...draft, kycStatuses })}
            idPrefix="crossborder-customers-kyc"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_CUSTOMERS_FILTERS}
      searchPlaceholder={intl.get("crossborder.customers.searchPlaceholder")}
      filterButtons={filterButtons}
      buildFilterTags={buildCustomersFilterTags}
      hasActiveFilters={hasActiveCustomersFilters}
      removeFilterTag={removeCustomersFilterTag}
      renderPanelContent={renderPanelContent}
      filteredItems={filteredItems}
      showExport={false}
      panelTitles={{
        country: intl.get("crossborder.customers.filterCountry"),
        kyc: intl.get("crossborder.customers.filterKyc"),
      }}
    />
  );
};
